// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1LgeR","signatureBlock":"Footer_signatureBlock__1uf5P","signature":"Footer_signature__2WtdA"};